module.exports = __webpack_public_path__ + "img/one.2ef9997e.svg";